import React from "react";

export default function FacebookBlackIcon() {
  return (
    <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.06044 8.93114L8.48714 6.15067H5.8192V4.34634C5.8192 3.58565 6.19189 2.84418 7.38678 2.84418H8.59967V0.476908C8.59967 0.476908 7.499 0.289062 6.44665 0.289062C4.24952 0.289062 2.81338 1.62078 2.81338 4.03156V6.15067H0.371094V8.93114H2.81338V15.6527H5.8192V8.93114H8.06044Z" fill="#020E27"/>
    </svg>

  );
}
